import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["myhouse_notice_select--arrow"] || "myhouse_notice_select--arrow"} xmlns="http://www.w3.org/2000/svg" width="13" height="8" {...props}><path d="M.97.97a.75.75 0 01.976-.073L2.03.97 6.5 5.439l4.47-4.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073L5.97 7.03l-5-5a.749.749 0 010-1.06z" fill="#C8CDD6" fillRule="nonzero" /></svg>);